import Settings from './Setting';
import CommonReducer from './CommonReducer';
import Auth from './Auth';
import ChatApp from './ChatApp';
import Courses from './Courses';
import Statistics from './Statistics';
import TMR from './TMR';
import CTD from './CTD';
import CTDTransient from './CTDTransient';

const reducers = {
  settings: Settings,
  auth: Auth,
  common: CommonReducer,
  chatApp: ChatApp,
  courses: Courses,
  statistics: Statistics,
  tmr: TMR,
  ctd: CTD,
  ctdTransient: CTDTransient,
};

export default reducers;
